module.exports = __webpack_public_path__ + "static/gallery38-bfcb302c76c52099e31fcce9d9016afc.png";